import { useState } from 'react'
import { useSpendContext } from './useSpendContext';
import { ApiUrl } from '../services'
import { axiosInstance as axios } from '../AxiosToken';
import { manageErrorPigApi, sleep } from '../utils';

export const usePost = () => {
  const { dispatch } = useSpendContext()
  const [error, setError] = useState(null)
  const [response, setResponse] = useState(null)
  const [isLoading, setIsLoading] = useState(null)

  const Post = async (path, data) => {
    setIsLoading(true)
    setError(null)
    let url = ApiUrl()
    // let path = 'expenses'

    try {
      let lnk = `${url}/api/${path}`
      if (process.env.NODE_ENV !== 'production') {
        const sleepDuration = 100
        console.group('Post Request')
        console.log('usePost: ', lnk);
        console.log('data: ', JSON.stringify(data,0,1));
        console.table(data)
        await sleep(sleepDuration)
        console.warn(`SLEEP ${sleepDuration}ms Enabled in usePost.jsx`)
        console.groupEnd()
      }

      const respAxios = await axios.post(lnk, data)
      let result = respAxios.data
      // console.log('getExpenses Responses Axios', result)
      if (process.env.NODE_ENV !== 'production') {
        console.table(result)
      }
      setResponse(result)
      setIsLoading(false)
      if (result.message) {
        dispatch({
          type: 'SET_NOTIF', payload: {
            message: result.message,
            type: 'success'
          }
        })
      }

    } catch (error) {
      let errorMessage = manageErrorPigApi(error)
      console.warn('ERROR', error)
      setError(error)
      dispatch({
        type: 'SET_NOTIF', payload: {
          message: (errorMessage) ? errorMessage : error.message,
          type: 'error'
        }
      })
      setIsLoading(false)
    }
  }
  return { Post, isLoading, error, response }
}


